module.exports = __webpack_public_path__ + "static/sigma_footer-de356927835b1073be8b7f10ac9558f2.svg";